

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"24"}, rest), [h('path', {"fill":"#FFF","fill-rule":"evenodd","d":"m2.406.909 17.056 10.234a1 1 0 0 1 0 1.714L2.406 23.091a1 1 0 0 1-1.515-.857V1.766A1 1 0 0 1 2.406.91Z"}, [])]);
};

        